import { formatDecimal, getDecimalPoints } from "./formatNumber";

export function getCurrencySymbol(currency) {
  if (typeof currency === "string") return currency;
  return currency?.symbol || currency?.code || "";
}

export function formatCurrency(amount, currency, options = {}) {
  const numericAmount = Number(amount ?? 0);
  const value = Number.isFinite(numericAmount) ? numericAmount : 0;
  const { decimals = getDecimalPoints(), trimZeros = true } = options;
  const formatted = formatDecimal(value, { decimals, trimZeros });
  return `${getCurrencySymbol(currency)} ${formatted}`;
}
